<template>
  <h2 style="text-align: center;">Monograms</h2>
  <div v-if="monogramPreview.leftChar.fontID != null">
    <form class="card col-md-10 offset-md-1">
      <div class="btn-group">
        <input
          type="radio"
          class="btn-check"
          name="options"
          id="option1"
          autocomplete="off"
          checked
          @change="changeNumOfChars('2')"
        />
        <label class="btn btn-secondary" for="option1">2 characters</label>

        <input
          type="radio"
          class="btn-check"
          name="options"
          id="option2"
          autocomplete="off"
          @change="changeNumOfChars('3')"
        />
        <label class="btn btn-secondary" for="option2">3 characters</label>
      </div>

      <div class="row mt-4">
        <div class="col-md-8">
          <div class="col-md-8">
            <div style="display: flex; margin:10px; justify-content: center;">
            <div>char A
          <div class="border-group">
            <vue-select
              title="Choose font type"
              :close-on-select="true"
              :min="1"
              :options="store.getAllFontsToMonogram()"
              label-by="fontName"
              value-by="fontID"
              searchable
              :model-value="monogramPreview.leftChar.fontID"
              @update:modelValue="(value) => {
              if (value !== null && value !== undefined) { 
              monogramPreview.leftChar.fontID = value;
              monogramPreview.leftChar.fontSizeID = Object.values(this.store.getAllFontSizes(value))[0].sizeID;
              this.updateCharColorsArray('leftChar', value, monogramPreview.leftChar.fontSizeID);
              }
              }"
            >
            </vue-select>
            &nbsp;
            <vue-select
              title="Choose font size"
              :close-on-select="true"
              :min="1"
              v-if="monogramPreview.leftChar.fontID"
              :options="store.getAllFontSizesToSelect(monogramPreview.leftChar.fontID)"
              label-by="sizeName"
              value-by="sizeID"
              searchable
              :model-value="monogramPreview.leftChar.fontSizeID"
              @update:modelValue="(value) => {
              if (value !== null && value !== undefined) { 
              monogramPreview.leftChar.fontSizeID = value;
              this.updateCharColorsArray('leftChar', monogramPreview.leftChar.fontID, value);
              }
              }"
            >
            </vue-select>
          </div>
          <div>
            select colors
          </div>
          </div>
          &nbsp;
          <div v-if="monogramPreview.numOfCharacters != '2'">char B
          <div class="border-group">
            <vue-select
              title="Choose font type"
              :close-on-select="true"
              :min="1"
              :options="store.getAllFontsToMonogram()"
              label-by="fontName"
              value-by="fontID"
              searchable
              :model-value="monogramPreview.middleChar.fontID"
              @update:modelValue="(value) => {
              if (value !== null && value !== undefined) { 
              monogramPreview.middleChar.fontID = value;
              monogramPreview.middleChar.fontSizeID = Object.values(this.store.getAllFontSizes(value))[0].sizeID;
              this.updateCharColorsArray('middleChar', value, monogramPreview.middleChar.fontSizeID);
              }
              }"
            >
            </vue-select>
            &nbsp;
            <vue-select
              title="Choose font size"
              :close-on-select="true"
              :min="1"
              v-if="
                monogramPreview.numOfCharacters != '2' &&
                monogramPreview.middleChar.fontID
              "
              :options="store.getAllFontSizesToSelect(monogramPreview.middleChar.fontID)"
              label-by="sizeName"
              value-by="sizeID"
              searchable
              :model-value="monogramPreview.middleChar.fontSizeID"
              @update:modelValue="(value) => {
              if (value !== null && value !== undefined) { 
              monogramPreview.middleChar.fontSizeID = value;
              this.updateCharColorsArray('middleChar', monogramPreview.middleChar.fontID, value);
              }
              }"
            >
            </vue-select>
          </div>
          </div>
          <span v-if="monogramPreview.numOfCharacters != '2'">&nbsp;</span>
          <div>char C
          <div class="border-group">
            <vue-select
              title="Choose font type"
              :close-on-select="true"
              :min="1"
              :options="store.getAllFontsToMonogram()"
              label-by="fontName"
              value-by="fontID"
              searchable
              :model-value="monogramPreview.rightChar.fontID"
              @update:modelValue="(value) => {
              if (value !== null && value !== undefined) { 
              monogramPreview.rightChar.fontID = value;
              monogramPreview.rightChar.fontSizeID = Object.values(this.store.getAllFontSizes(value))[0].sizeID;
              this.updateCharColorsArray('rightChar', value, monogramPreview.rightChar.fontSizeID);
              }
              }"
            >
            </vue-select>
            &nbsp;
            <vue-select
              title="Choose font size"
              :close-on-select="true"
              :min="1"
              v-if="monogramPreview.rightChar.fontID"
              :options="store.getAllFontSizesToSelect(monogramPreview.rightChar.fontID)"
              label-by="sizeName"
              value-by="sizeID"
            searchable
              :model-value="monogramPreview.rightChar.fontSizeID"
              @update:modelValue="(value) => {
              if (value !== null && value !== undefined) { 
              monogramPreview.rightChar.fontSizeID = value;
              this.updateCharColorsArray('rightChar', monogramPreview.rightChar.fontID, value);
              }
              }"
            >
            </vue-select>
          </div>
          </div>
          </div>
          
          <!-- Color Selection Buttons -->
          <div style="margin: 10px; display: flex; justify-content: center; gap: 10px;">
            <span :class="monogramPreview.multiColor == false ? 'one-color color-btn active-color-btn' : 'one-color color-btn'" @click="changeMultiColor(false)">ABC</span>
            <span :class="monogramPreview.multiColor == true ? 'multi-colors color-btn active-color-btn' : 'multi-colors color-btn'" @click="changeMultiColor(true)">
              <span class="letter-1">A</span>
              <span class="letter-2">B</span>
              <span class="letter-3">C</span>
            </span>
          </div>
          
          <!-- Color Selection for Same Color Mode -->
          <div v-if="monogramPreview.multiColor == false" style="margin: 10px; display: flex; justify-content: center; gap: 10px;">
            <div style="text-align: center;">
              <div style="font-weight: bold; margin-bottom: 5px;">Colors for all letters:</div>
              <div style="display: flex; gap: 10px; justify-content: center;">
                <div v-for="(color, colorIndex) in getMaxLayersForAllChars()" :key="colorIndex">
                  <vue-select
                    title="Choose color"
                    :close-on-select="true"
                    :options="store.getAllColors()"
                    label-by="colorName"
                    value-by="colorID"
                    searchable
                    :model-value="monogramPreview.leftChar.defaultColors[colorIndex] || Object.values(store.getAllColors())[0].colorID"
                    @update:modelValue="(value) => updateAllCharsColor(colorIndex, value)"
                  >
                  <template #label="{ selected }">
                      <template v-if="selected">
                        <div class="dd-color">
                          <span class="select-color-name" :style="{ backgroundColor: selected.color }">
                          </span>
                          {{ selected.colorName }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="dd-color">
                          <span class="select-color-name"
                            :style="{
                              backgroundColor:
                                store.allColors.value[ArtToPopup.defaultColors[index]]
                                  .color,
                            }"
                          >
                          </span>

                          {{
                            store.allColors.value[ArtToPopup.defaultColors[index]]
                              .colorName
                          }}
                        </div>
                      </template>
                    </template>
                    <template #dropdown-item="{ option }">
                      <div class="dd-color">
                        <span class="select-color-name" :style="{ backgroundColor: option.color }">
                        </span>
                        {{ option.colorName }}
                      </div>
                    </template>
                  </vue-select>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Color Selection for Multi Color Mode -->
          <div v-if="monogramPreview.multiColor == true" style="margin: 10px;">
            <div style="display: flex; justify-content: center; gap: 20px;">
              <!-- Left Char Colors -->
              <div style="text-align: center;">
                <div style="font-weight: bold; margin-bottom: 5px;">Char A Colors:</div>
                <div style="display: flex; flex-direction: column; gap: 5px;">
                  <div v-for="(color, colorIndex) in getMaxLayersForChar('leftChar')" :key="colorIndex">
                    <vue-select
                      title="Choose color"
                      :close-on-select="true"
                      :options="store.getAllColors()"
                      label-by="colorName"
                      value-by="colorID"
                      searchable
                      :model-value="monogramPreview.leftChar.defaultColors[colorIndex] || Object.values(store.getAllColors())[0].colorID"
                      @update:modelValue="(value) => updateCharColor('leftChar', colorIndex, value)"
                    >
                    <template #label="{ selected }">
                      <template v-if="selected">
                        <div class="dd-color">
                          <span class="select-color-name" :style="{ backgroundColor: selected.color }">
                          </span>
                          {{ selected.colorName }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="dd-color">
                          <span class="select-color-name"
                            :style="{
                              backgroundColor:
                                store.allColors.value[ArtToPopup.defaultColors[index]]
                                  .color,
                            }"
                          >
                          </span>

                          {{
                            store.allColors.value[ArtToPopup.defaultColors[index]]
                              .colorName
                          }}
                        </div>
                      </template>
                    </template>
                    <template #dropdown-item="{ option }">
                      <div class="dd-color">
                        <span class="select-color-name" :style="{ backgroundColor: option.color }">
                        </span>
                        {{ option.colorName }}
                      </div>
                    </template>
                    </vue-select>
                  </div>
                </div>
              </div>
              
              <!-- Middle Char Colors -->
              <div v-if="monogramPreview.numOfCharacters == '3'" style="text-align: center;">
                <div style="font-weight: bold; margin-bottom: 5px;">Char B Colors:</div>
                <div style="display: flex; flex-direction: column; gap: 5px;">
                  <div v-for="(color, colorIndex) in getMaxLayersForChar('middleChar')" :key="colorIndex">
                    <vue-select
                      title="Choose color"
                      :close-on-select="true"
                      :options="store.getAllColors()"
                      label-by="colorName"
                      value-by="colorID"
                      searchable
                      :model-value="monogramPreview.middleChar.defaultColors[colorIndex] || Object.values(store.getAllColors())[0].colorID"
                      @update:modelValue="(value) => updateCharColor('middleChar', colorIndex, value)"
                    >
                    <template #label="{ selected }">
                      <template v-if="selected">
                        <div class="dd-color">
                          <span class="select-color-name" :style="{ backgroundColor: selected.color }">
                          </span>
                          {{ selected.colorName }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="dd-color">
                          <span class="select-color-name"
                            :style="{
                              backgroundColor:
                                store.allColors.value[ArtToPopup.defaultColors[index]]
                                  .color,
                            }"
                          >
                          </span>

                          {{
                            store.allColors.value[ArtToPopup.defaultColors[index]]
                              .colorName
                          }}
                        </div>
                      </template>
                    </template>
                    <template #dropdown-item="{ option }">
                      <div class="dd-color">
                        <span class="select-color-name" :style="{ backgroundColor: option.color }">
                        </span>
                        {{ option.colorName }}
                      </div>
                    </template>
                    </vue-select>
                  </div>
                </div>
              </div>
              
              <!-- Right Char Colors -->
              <div style="text-align: center;">
                <div style="font-weight: bold; margin-bottom: 5px;">Char {{ monogramPreview.numOfCharacters == '3' ? 'C' : 'B' }} Colors:</div>
                <div style="display: flex; flex-direction: column; gap: 5px;">
                  <div v-for="(color, colorIndex) in getMaxLayersForChar('rightChar')" :key="colorIndex">
                    <vue-select
                      title="Choose color"
                      :close-on-select="true"
                      :options="store.getAllColors()"
                      label-by="colorName"
                      value-by="colorID"
                      searchable
                      :model-value="this.store.allFonts.value[monogramPreview.rightChar.fontID].defaultFontColors ? this.store.allFonts.value[monogramPreview.rightChar.fontID].defaultFontColors[colorIndex] : monogramPreview.rightChar.defaultColors[colorIndex]"
                      @update:modelValue="(value) => updateCharColor('rightChar', colorIndex, value)"
                    >
                    <template #label="{ selected }">
                      <template v-if="selected">
                        <div class="dd-color">
                          <span class="select-color-name" :style="{ backgroundColor: selected.color }">
                          </span>
                          {{ selected.colorName }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="dd-color">
                          <span class="select-color-name"
                            :style="{
                              backgroundColor:
                                store.allColors.value[ArtToPopup.defaultColors[index]]
                                  .color,
                            }"
                          >
                          </span>

                          {{
                            store.allColors.value[ArtToPopup.defaultColors[index]]
                              .colorName
                          }}
                        </div>
                      </template>
                    </template>
                    <template #dropdown-item="{ option }">
                      <div class="dd-color">
                        <span class="select-color-name" :style="{ backgroundColor: option.color }">
                        </span>
                        {{ option.colorName }}
                      </div>
                    </template>
                    </vue-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <div class="col-md-8" style="align-self: center;">
        <div style="display: inline-flex; margin: 10px; margin-bottom: 0px; width: 80%; justify-content: center;">
          <MDBInput
            label="distance1"
            type="number"
            v-model="monogramPreview.distance1"
          />
          &nbsp;
          <MDBInput
            v-if="monogramPreview.numOfCharacters != '2'"
            label="distance2"
            type="number"
            v-model="monogramPreview.distance2"
          />
        </div>
        <div style="margin: 10px; width: 80%; display: inline-flex; justify-content: center;">
        <MDBInput label="Monogram name" v-model="monogramPreview.monogramName" /></div>
        <div style="display: inline-flex;">
          <div
            :class="
              this.monogramPreview.align == 'bottom' ? 'active-align' : 'null'
            "
            title="align bottom"
          >
            <icon-svg
              icon="carbon:align-vertical-bottom"
              @click="changeAlign('bottom')"
              :height="25"
              :width="25"
              
              style="margin-inline: 8px; cursor: pointer "

            />
          </div>
          <div
            :class="
              this.monogramPreview.align == 'center' ? 'active-align' : 'null'
            "
            title="align center"
          >
            <icon-svg
              icon="carbon:align-vertical-center"
              @click="changeAlign('center')"
              :height="25"
              :width="25"
              style="margin-inline: 8px ; cursor: pointer"
            />
          </div>
          <div
            :class="this.monogramPreview.align == 'top' ? 'active-align' : 'null'"
            title="align top"
          >
            <icon-svg
              icon="carbon:align-vertical-top"
              @click="changeAlign('top')"
              :height="25"
              :width="25"
              style="margin-inline: 8px; cursor: pointer"
            />
          </div>
        </div>
        <div title="Add monogram" style="margin-bottom: 20px; margin-top: 20px; cursor: pointer">
          <icon-svg
            icon="material-symbols:add-circle-outline"
            :height="35"
            :width="35"
            @click="addMonogram()"
          />
        </div>
      </div>
      </div>
        
        <div v-if="this.monogramPreview.leftChar.fontID != null && this.monogramPreview.rightChar.fontID != null" class="col-md-4" style="top: 80px; position: relative;">
          <!-- :colorLeftChar="this.monogramPreview.leftChar.defaultColors"
            :colorMiddleChar="
              this.monogramPreview.numOfCharacters == '3'
                ? this.monogramPreview.middleChar.defaultColors
                : null
            "
            :colorRightChar="this.monogramPreview.rightChar.defaultColors" -->


            <!-- :colorLeftChar="monogramObjectToShow.colorsLeftChar" :colorMiddleChar="
                              monogramObjectToShow.colorsMiddleChar
                            " :colorRightChar="
                              monogramObjectToShow.colorsRightChar
                            " -->
          <MonogramPreview
            :monogramObj="this.monogramPreview"

            :colorLeftChar="monogramPreview.leftChar.defaultColors"
            :colorMiddleChar="
              this.monogramPreview.numOfCharacters == '3'
                ? monogramPreview.middleChar.defaultColors
                : null
            "
            :colorRightChar="monogramPreview.rightChar.defaultColors"
            :char1="'A'"
            :char2="this.monogramPreview.numOfCharacters == '3' ? 'B' : null"
            :char3="this.monogramPreview.numOfCharacters == '3' ? 'C' : 'B'"
            :align="this.monogramPreview.align"
            :distance1="this.monogramPreview.distance1"
            :distance2="
              this.monogramPreview.numOfCharacters == '3'
                ? this.monogramPreview.distance2
                : null
            "
            :dpi="getDpi(100.0, this.monogramPreview)"
          >
          </MonogramPreview>
        </div>
        </div>
    </form>
  </div>
  <div v-else>
    <h6 style="color: red;">
      No fonts were found in the database!
    </h6>
  </div>
  <div class="row mt-2">
    <div class="col-md-10">
      <table class="table responsive-table">
        <thead>
          <tr>
            <th>Monogram name</th>
            <th>Num of chars</th>
            <th>Preview</th>
            <th>Remove monogram</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(monogram, index) in store.getAllMonogramsAvailableFonts()" :key="index">
            <td>{{ monogram.monogramName }}</td>
            <td>{{ monogram.numOfCharacters }}</td>
            <td>              
              <!-- left: '85px',
              top:
                (58.5 -
                  (this.getMaxFontHeight(monogram) *
                    getDpi(47.0, monogram)) /
                    254.0) /
                  2 +
                'px', -->
              <div
                :style="{
                  position: 'relative',
                }">

<!-- :colorLeftChar="monogram.leftChar.defaultColors"
                  :colorMiddleChar="
                    monogram.numOfCharacters == '3'
                      ? monogram.middleChar.defaultColors
                      : null
                  "
                  :colorRightChar="monogram.rightChar.defaultColors" -->
                <MonogramPreview
                  :monogramObj="monogram"
                  :colorLeftChar="monogram.leftChar.defaultColors"
                  :colorMiddleChar="
                    monogram.numOfCharacters == '3'
                      ? monogram.middleChar.defaultColors
                      : null
                  "
                  :colorRightChar="monogram.rightChar.defaultColors"
                  :char1="'A'"
                  :char2="monogram.numOfCharacters == '3' ? 'B' : null"
                  :char3="monogram.numOfCharacters == '3' ? 'C' : 'B'"
                  :align="monogram.defaultAlignType"
                  :distance1="monogram.distance1"
                  :distance2="monogram.distance2"
                  :dpi="getDpi(47.0, monogram)"
                >
                </MonogramPreview>
              </div>
            </td>
            <td>
              <icon-svg
                :height="25"
                :width="25"
                icon="ic:baseline-delete"
                style="cursor: pointer"
                @click="removeMonogram(monogram.monogramID)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { storeToRefs } from "pinia";
import { designerStore } from "@/stores/designerStore";
import VueSelect from "vue-next-select";
import { MDBInput } from "mdb-vue-ui-kit";
import MonogramPreview from "./MonogramPreview.vue";

export default {
  setup() {
    const store = designerStore();
    const { fontList } = storeToRefs(store);

    return {
      store,
      fontList,
    };
  },

  components: {
    VueSelect,
    MDBInput,
    MonogramPreview,
  },
  data() {
    return {
      numOfCharacters: "2",
      rightChar: null,
      leftChar: null,
      middleChar: null,
      monogramName: "",
      align: "middle",
      monogramPreview: {
        monogramName: "",
        numOfCharacters: "2",
        multiColor: false,
        leftChar: {
          fontID: this.store.getAllFontsToMonogramDict().length != 0 ? Object.values(this.store.getAllFontsToMonogramDict())[0].fontID : null,
          fontSizeID: this.store.getAllFontsToMonogramDict().length != 0 ? Object.values(this.store.getAllFontsToMonogramDict()[Object.values(this.store.getAllFontsToMonogramDict())[0].fontID].sizes)[0].sizeID : null,
          defaultColors: [],
        },
        //{
        middleChar: null,
        // fontID: 1,
        // fontSizeID: 1,
        // defaultColors: [1],
        // },
        rightChar: {
          fontID: this.store.getAllFontsToMonogramDict().length != 0 ? Object.values(this.store.getAllFontsToMonogramDict())[0].fontID : null,
          fontSizeID: this.store.getAllFontsToMonogramDict().length != 0 ? Object.values(this.store.getAllFontsToMonogramDict()[Object.values(this.store.getAllFontsToMonogramDict())[0].fontID].sizes)[0].sizeID : null,
          defaultColors: [],
        },
        distance1: 0,
        distance2: 0,
        align: "center",
        maxMonogramHeight: 1,
      },
      distance1: 0,
      distance2: 0,
      dpi: 0,
    };
  },
  beforeMount() {
    console.log(this.store.getAllFontsToMonogramDict());
    if(Object.values(this.store.getAllFontsToMonogramDict()).length != 0) {
      const firstFont = Object.values(this.store.getAllFontsToMonogramDict())[0];
      const firstSize = Object.values(firstFont.sizes)[0];
      const defaultColorId = Object.values(this.store.getAllColors())[0].colorID;
      const maxLayers = firstSize.maxLayers || 1;
      
      this.monogramPreview.leftChar = {
        fontID: firstFont.fontID,
        fontSizeID: firstSize.sizeID,
        defaultColors: Array(maxLayers).fill(defaultColorId)
        }
      this.monogramPreview.rightChar = {
        fontID: firstFont.fontID,
        fontSizeID: firstSize.sizeID,
        defaultColors: Array(maxLayers).fill(defaultColorId)
      } 
    }
  },
  mounted() {
    if(this.monogramPreview.leftChar.fontID != null) {
        this.monogramPreview.maxMonogramHeight = this.getMaxFontHeight(
          this.monogramPreview
      );
      this.dpi = (100.0 / this.monogramPreview.maxMonogramHeight) * 254.0;
    }
  },
  methods: {
    changeNumOfChars(num) {
      this.numOfCharacters = num;
      this.monogramPreview.numOfCharacters = num;
      if (num == 2) {
        this.monogramPreview.middleChar = null;
      } else {
        const firstFont = Object.values(this.store.getAllFontsToMonogramDict())[0];
        const firstSize = Object.values(firstFont.sizes)[0];
        const defaultColorId = Object.values(this.store.getAllColors())[0].colorID;
        const maxLayers = firstSize.maxLayers || 1;
        
        // יצירת האות האמצעית
        this.monogramPreview.middleChar = {
          fontID: firstFont.fontID,
          fontSizeID: firstSize.sizeID,
          defaultColors: [],
        };
        
        // קביעת הצבעים לפי מצב multiColor
        if (this.monogramPreview.multiColor) {
          // במצב רב-צבעי - השתמש בצבעי ברירת המחדל של הפונט
          const fontData = this.store.allFonts.value[firstFont.fontID];
          if (fontData && fontData.defaultFontColors) {
            this.monogramPreview.middleChar.defaultColors = [...fontData.defaultFontColors];
          } else {
            this.monogramPreview.middleChar.defaultColors = Array(maxLayers).fill(defaultColorId);
          }
        } else {
          // במצב צבע יחיד - העתק את הצבעים של leftChar
          const leftCharColors = this.monogramPreview.leftChar.defaultColors || [];
          this.monogramPreview.middleChar.defaultColors = [];
          for (let i = 0; i < maxLayers; i++) {
            this.monogramPreview.middleChar.defaultColors[i] = leftCharColors[i % leftCharColors.length] || defaultColorId;
          }
        }
      }
    },
    addMonogram() {
      this.store.addMonogram(this.monogramPreview);
    },
    changeAlign(align) {
      this.monogramPreview.align = align;
    },
    getMaxFontHeight(monogram) {
      var maxHeight = 0;
      if (monogram.numOfCharacters == "2") {
        maxHeight = Math.max(
          this.store.getAllFontsToMonogramDict()[monogram.leftChar.fontID].sizes[
            monogram.leftChar.fontSizeID
          ].FontHeight,
          this.store.getAllFontsToMonogramDict()[monogram.rightChar.fontID].sizes[
            monogram.rightChar.fontSizeID
          ].FontHeight
        );
      } else {
        maxHeight = Math.max(
          this.store.getAllFontsToMonogramDict()[monogram.leftChar.fontID].sizes[
            monogram.leftChar.fontSizeID
          ].FontHeight,
          this.store.getAllFontsToMonogramDict()[monogram.rightChar.fontID].sizes[
            monogram.rightChar.fontSizeID
          ].FontHeight,
          this.store.getAllFontsToMonogramDict()[monogram.middleChar.fontID].sizes[
            monogram.middleChar.fontSizeID
          ].FontHeight
        );
      }
      return maxHeight;
    },
    getDpi(size, monogram) {
      monogram.maxMonogramHeight = this.getMaxFontHeight(monogram);
      return (size / monogram.maxMonogramHeight) * 254.0;
    },
    removeMonogram(monogramID) {
      this.store.removeMonogram(monogramID);
    },
    changeMultiColor(multiColorTF) {
      this.monogramPreview.multiColor = multiColorTF;
      if (this.monogramPreview.multiColor == false) {
        // העתקת צבעים של האות השמאלית לשאר האותיות
        if (this.monogramPreview.numOfCharacters == '3' && this.monogramPreview.middleChar) {
          this.copyColors(this.monogramPreview.middleChar.defaultColors, this.monogramPreview.leftChar.defaultColors);
        }
        this.copyColors(this.monogramPreview.rightChar.defaultColors, this.monogramPreview.leftChar.defaultColors);
      } else {
        // במצב רב צבעי - תמיד החזר את צבעי ברירת המחדל של כל פונט
        const defaultColorId = Object.values(this.store.getAllColors())[0].colorID;
        
        if (this.monogramPreview.leftChar) {
          const leftFontData = this.store.allFonts.value[this.monogramPreview.leftChar.fontID];
          if (leftFontData && leftFontData.defaultFontColors) {
            this.monogramPreview.leftChar.defaultColors = [...leftFontData.defaultFontColors];
          } else {
            const maxLayers = leftFontData?.layerCount || 1;
            this.monogramPreview.leftChar.defaultColors = Array(maxLayers).fill(defaultColorId);
          }
        }
        
        if (this.monogramPreview.numOfCharacters == '3' && this.monogramPreview.middleChar) {
          const middleFontData = this.store.allFonts.value[this.monogramPreview.middleChar.fontID];
          if (middleFontData && middleFontData.defaultFontColors) {
            this.monogramPreview.middleChar.defaultColors = [...middleFontData.defaultFontColors];
          } else {
            const maxLayers = middleFontData?.layerCount || 1;
            this.monogramPreview.middleChar.defaultColors = Array(maxLayers).fill(defaultColorId);
          }
        }
        
        if (this.monogramPreview.rightChar) {
          const rightFontData = this.store.allFonts.value[this.monogramPreview.rightChar.fontID];
          if (rightFontData && rightFontData.defaultFontColors) {
            this.monogramPreview.rightChar.defaultColors = [...rightFontData.defaultFontColors];
          } else {
            const maxLayers = rightFontData?.layerCount || 1;
            this.monogramPreview.rightChar.defaultColors = Array(maxLayers).fill(defaultColorId);
          }
        }
      }
    },
    copyColors(targetColors, sourceColors) {
      for (var i = 0; i < targetColors.length; i++) {
        targetColors[i] = sourceColors[i % sourceColors.length];
      }
    },
    getMaxLayersForChar(charType) {
      if (!this.monogramPreview[charType] || !this.monogramPreview[charType].fontID) {
        return [];
      }
      
      const fontId = this.monogramPreview[charType].fontID;
      // const fontSizeId = this.monogramPreview[charType].fontSizeID;
      
      if (!this.store.allFonts.value[fontId]) {
        return [];
      }
      
      const maxLayers = this.store.allFonts.value[fontId].layerCount || 1; //this.store.getAllFontsToMonogramDict()[fontId].sizes[fontSizeId].maxLayers || 1;
      return Array.from({ length: maxLayers }, (_, i) => i);
    },
    getMaxLayersForAllChars() {
      let maxLayers = 0;
      
      // בדיקת האות השמאלית
      if (this.monogramPreview.leftChar && this.monogramPreview.leftChar.fontID) {
        const leftMaxLayers = this.store.allFonts.value[this.monogramPreview.leftChar.fontID].layerCount || 1; //this.store.getAllFontsToMonogramDict()[this.monogramPreview.leftChar.fontID]?.sizes[this.monogramPreview.leftChar.fontSizeID]?.maxLayers || 1;
        maxLayers = Math.max(maxLayers, leftMaxLayers);
      }
      
      // בדיקת האות האמצעית
      if (this.monogramPreview.numOfCharacters == '3' && this.monogramPreview.middleChar && this.monogramPreview.middleChar.fontID) {
        const middleMaxLayers = this.store.allFonts.value[this.monogramPreview.middleChar.fontID].layerCount || 1; //this.store.getAllFontsToMonogramDict()[this.monogramPreview.middleChar.fontID]?.sizes[this.monogramPreview.middleChar.fontSizeID]?.maxLayers || 1;
        maxLayers = Math.max(maxLayers, middleMaxLayers);
      }
      
      // בדיקת האות הימנית
      if (this.monogramPreview.rightChar && this.monogramPreview.rightChar.fontID) {
        const rightMaxLayers = this.store.allFonts.value[this.monogramPreview.rightChar.fontID].layerCount || 1; //this.store.getAllFontsToMonogramDict()[this.monogramPreview.rightChar.fontID]?.sizes[this.monogramPreview.rightChar.fontSizeID]?.maxLayers || 1;
        maxLayers = Math.max(maxLayers, rightMaxLayers);
      }
      
      return Array.from({ length: maxLayers }, (_, i) => i);
    },
    updateAllCharsColor(colorIndex, colorValue) {
      // עדכון צבע לכל האותיות באותו אינדקס
      if (this.monogramPreview.leftChar.defaultColors.length > colorIndex) {
        this.monogramPreview.leftChar.defaultColors[colorIndex] = colorValue;
      }
      
      if (this.monogramPreview.numOfCharacters == '3' && this.monogramPreview.middleChar && this.monogramPreview.middleChar.defaultColors.length > colorIndex) {
        this.monogramPreview.middleChar.defaultColors[colorIndex] = colorValue;
      }
      
      if (this.monogramPreview.rightChar.defaultColors.length > colorIndex) {
        this.monogramPreview.rightChar.defaultColors[colorIndex] = colorValue;
      }
    },
    updateCharColor(charType, colorIndex, colorValue) {
      // עדכון צבע לאות ספציפית
      if (this.monogramPreview[charType] && this.monogramPreview[charType].defaultColors) {
        if (this.monogramPreview[charType].defaultColors.length <= colorIndex) {
          // הרחבת מערך הצבעים במידת הצורך
          while (this.monogramPreview[charType].defaultColors.length <= colorIndex) {
            this.monogramPreview[charType].defaultColors.push(Object.values(this.store.getAllColors())[0].colorID);
          }
        }
        this.monogramPreview[charType].defaultColors[colorIndex] = colorValue;
      }
    },
    updateCharColorsArray(charType, fontId, sizeId) {
      // עדכון מערך הצבעים לפי מספר השכבות החדש
      if (!this.monogramPreview[charType] || !fontId || !sizeId) return;
      
      const fontData = this.store.allFonts.value[fontId];
      if (!fontData || !fontData.sizes[sizeId]) return;
      
      const maxLayers = fontData.layerCount || 1;
      const defaultColorId = Object.values(this.store.getAllColors())[0].colorID;
      
      if (this.monogramPreview.multiColor) {
        // במצב רב צבעי - השתמש בצבעי ברירת המחדל של הפונט החדש
        if (fontData.defaultFontColors) {
          this.monogramPreview[charType].defaultColors = [...fontData.defaultFontColors];
        } else {
          this.monogramPreview[charType].defaultColors = Array(maxLayers).fill(defaultColorId);
        }
      } else {
        // במצב צבע יחיד - שמור על הצבעים הקיימים (של leftChar)
        const currentColors = this.monogramPreview[charType].defaultColors || [];
        
        if (charType === 'leftChar') {
          // אם זה leftChar ומחליפים פונט - השתמש בצבעי ברירת מחדל של הפונט החדש או שמור על הקיימים
          const newColors = [];
          for (let i = 0; i < maxLayers; i++) {
            if (currentColors[i] !== undefined) {
              newColors[i] = currentColors[i];
            } else {
              newColors[i] = defaultColorId;
            }
          }
          this.monogramPreview[charType].defaultColors = newColors;
          
          // עדכן את שאר האותיות להיות כמו leftChar
          if (this.monogramPreview.rightChar) {
            this.copyColors(this.monogramPreview.rightChar.defaultColors, newColors);
          }
          if (this.monogramPreview.numOfCharacters == '3' && this.monogramPreview.middleChar) {
            this.copyColors(this.monogramPreview.middleChar.defaultColors, newColors);
          }
        } else {
          // אם זה לא leftChar - השתמש בצבעים של leftChar
          const leftCharColors = this.monogramPreview.leftChar.defaultColors || [];
          const newColors = [];
          for (let i = 0; i < maxLayers; i++) {
            newColors[i] = leftCharColors[i % leftCharColors.length] || defaultColorId;
          }
          this.monogramPreview[charType].defaultColors = newColors;
        }
      }
    },
  },
};
</script>

<style scoped>
.active-align {
  background-color: aliceblue;
}
.border-group {
  /* border: solid 2px black; */
  width: 10%;
  /* text-align: -webkit-center; */
}
.col-md-6 .char-container {
  top: 40px;
}

  .dd-color {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px 10px;
    min-height: 30px;
    line-height: 1.3;
    word-wrap: break-word;
    white-space: normal;
  }
  .select-color-name {
    height: 20px;
    width: 20px;
    min-height: 20px;
    min-width: 20px;
    border-radius: 50%;
    display: block;
    flex-shrink: 0;
    align-self: center;
  }

.letter-1 {
  color: #72984F;
}
.letter-2 {
  color: #FF3535;
}
.letter-3 {
  color: #561BFF;
}
.color-btn {
  border: solid 1px;
  padding: 3px 10px 3px 10px;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
}
.one-color {
  border-radius: 1rem 0px 0px 1rem;
}
.multi-colors {    
  border-radius: 0px 1rem 1rem 0px;
}
.active-color-btn {
  background: #EDEDED;
}
</style>

<style>
/* .vue-select-header {
  position: relative !important;
} */
</style>